import type { ColumnDefinition } from "@frui.ts/dataviews";
import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import { Badge } from "react-bootstrap";
import OutagesViewModel from "viewModels/administration/outages/outagesViewModel";
import SystemComponentOutageState from "entities/systemComponentOutageState";
import { formatDateTime } from "utils/localizations";
import ListView from "../../common/list";
import OutageFilters from "./outageFilters";
import type SystemComponentOutageResponse from "entities/systemComponentOutageResponse";

const OutagesView: ViewComponent<OutagesViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<SystemComponentOutageResponse>[] = [
    {
      title: vm.translateAttribute("systemComponentId"),
      property: "systemComponentId",
      valueFormatter: props => vm.getSystemComponentName(props.value),
    },
    {
      title: vm.translateAttribute("visibleSince"),
      property: "visibleSince",
      valueFormatter: props => formatDateTime(props.value),
    },
    {
      title: vm.translateAttribute("validSince"),
      property: "validSince",
      valueFormatter: props => formatDateTime(props.value),
    },
    {
      title: vm.translateAttribute("validUntil"),
      property: "validUntil",
      valueFormatter: props => formatDateTime(props.value),
    },
    {
      title: vm.translateAttribute("systemComponentOutageState"),
      property: "systemComponentOutageState",
      valueFormatter: props => {
        let variant: string;
        switch (props.value) {
          case SystemComponentOutageState.Planned:
            variant = "warning";
            break;
          case SystemComponentOutageState.Active:
            variant = "primary";
            break;
          case SystemComponentOutageState.Passed:
          default:
            variant = "light";
            break;
        }

        return (
          <Badge variant={variant} className="p-2">
            {vm.translateState(props.value)}
          </Badge>
        );
      },
    },
  ];

  return (
    <ListView
      rowProps={item => {
        if (item.isDeleted) {
          return {
            className: "table-danger",
          };
        }

        return {};
      }}
      columns={columns}
      vm={vm}
      aboveTable={<OutageFilters vm={vm} />}
    />
  );
});

registerView(OutagesView, OutagesViewModel);
